<template>
  <div class="nearby-routes-wrap">

    <div>附近的路線:</div>

    <div>
          <span
            v-for="(route, index) in routes"
            :key="index"
            class="nearby-routes"
          >
            <router-link :to="{
                name: 'routeinfo',
                params: {
                    id: route.routeid
                }
            }">
                {{ route.routec }}
            </router-link>
          </span>

    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
  name: "NearbyRoutes",
  computed: {
    ...mapState('nearbyRoutes', ['routes'])
  },
  methods: {
    ...mapActions('nearbyRoutes', ['getNearbyRouteList'])
  },
  mounted() {
    this.getNearbyRouteList();
  }
}
</script>

<style scoped>
.nearby-routes {
  font-size: 120%;
  display: inline-block;
  padding: 4px 8px;
}

.nearby-routes::after {
  content: ", ";
  margin-right: 2px;
}

.nearby-routes:last-child::after {
  content: "";
}

.nearby-routes-wrap {
  margin-top: 16px;
  margin-bottom: 16px;
  line-height: 24px;
}
</style>
